<template>
  <div style="height: 100%; overflow: auto">
    <div v-for = "lemma in lemmas" :key="lemma['key']">
      <component v-bind:is="superLemma && lemma['key'] ? 'h2' : 'h1'"><span class="lemma" v-html="lemma.lemma['expression']"></span>&emsp;<span class="definition"  v-html="lemma.lemma['definition']"></span></component>
      <table class="table table-sm">
        <thead>
        </thead>
        <tbody>
        <tr v-for = "entry in lemma['entries']" :key="entry['row_number']"
            v-bind:class="{'table-active': entryIDs.indexOf(entry['entry_id']) !== -1}">
            <td style="width:20%" v-html="entry['expression']"></td>
            <td style="width:30%" v-html="entry['citation']"></td>
            <td v-html="entry['description']"></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  
  export default {
    data () {
      return {
        lemmas: [],
        lemmaIDs: []
      }
    },

    props: ['lemmaID', 'entryIDs', 'superLemma'],

    watch: {
      lemmaID: function (val) {
        this.lemmaIDs = [val]
        if (this.superLemma) {
          axios.post("/db/zettelkastensuperlemma", {superlemma_id: val})
            .then(response => {this.lemmaIDs = [val].concat(response.data.rows.map(x => x.lemma_id));})
            .catch(e => {console.log(e)})
        }
      },

      lemmaIDs: function (val) {
        let a = []
        for(let i = 0; i < val.length; ++i) {
          a[i] = {key: i, lemma: {}, entries: []};
        }
        this.lemmas = a;
        for(let i = 0; i < val.length; ++i) {
          axios.post("/db/zettelkastenlemma", {lemma_id: val[i]})
            .then(response => {this.lemmas[i].lemma = response.data.rows[0];})
            .catch(e => {console.log(e)})
          axios.post("/db/zettelkastenentries", {lemma_id: val[i]})
            .then(response => {this.lemmas[i].entries = response.data.rows})
            .catch(e => {console.log(e)})
        }
      }
    }
  }
</script>

<style>
h1 {
  display: block;
  font-size: 1.5em;
  margin-top: 0.67em;
  margin-bottom: 0.67em;
}

h2 {
  display: block;
  font-size: 1.3em;
  margin-top: 0.67em;
  margin-bottom: 0.67em;
}

.cun_sign {
  text-transform: lowercase;
  font-variant: small-caps;
}
.cun_det {
  vertical-align: super;
  font-size: smaller;
}
.cun_pc {
  vertical-align: super;
  font-size: smaller;
  font-style: italic;
}
.cun_r_con {
  vertical-align: super;
  font-size: smaller;
}
.cun_index {
  vertical-align: sub;
  font-size: smaller;
}
.cun_desc {
  font-style: italic;
  color: gray;
}
.italic {
  font-style: italic;
}
.sub {
  vertical-align: sub;
  font-size: smaller;
}
.super {
  vertical-align: super;
  font-size: smaller;
}
.lemma {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/ZettelkastenLemma.vue